import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { loadLocalities } from '../../../../../redux/asyncActions/reportSummaryDictionaries';
import { DropdownRender } from '../../../components/DropdownRender';

export const LocalitySelect = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const localities = useSelector((state) => state.reportSummaryDictionaries.localities);
  const currentUser = useSelector((state) => state.currentUser);
  const form = Form.useFormInstance();
  const regionIds = Form.useWatch('regionIds', form);
  const localityIds = Form.useWatch('localityIds', form);
  const [isLoading, setIsLoading] = useState(false);

  const userLocalities = currentUser.localities || [];
  const source = userLocalities.length > 0 ? userLocalities : localities;

  const options = source.map((item) => ({
    label: item.nameRu,
    value: item.id,
  }));

  const allIds = source.map((item) => item.id);

  const handleSelectAll = () => {
    const shouldSelectAll = !localityIds || localityIds.length !== allIds.length;
    form.setFieldsValue({ localityIds: shouldSelectAll ? allIds : [] });
  };

  useEffect(() => {
    if (userLocalities.length > 0) return;
    if (regionIds !== undefined && (regionIds || []).length > 0) {
      dispatch(loadLocalities(regionIds, setIsLoading));
    }
    form.setFieldsValue({ localityIds: [] });
  }, [dispatch, regionIds, form, userLocalities.length]);

  const isDisabled =
    userLocalities.length === 0 &&
    (regionIds === undefined || regionIds.length === 0 || localities.length === 0 || isLoading);

  return (
    <Form.Item
      name='localityIds'
      rules={[{ required: true, message: t('error.requiredField') }]}
    >
      <Select
        mode='multiple'
        maxTagCount='responsive'
        loading={isLoading}
        style={{ minWidth: 200 }}
        placeholder={t('governmentServiceEducation.locality')}
        disabled={isDisabled}
        options={options}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        optionFilterProp='label'
        dropdownRender={(menu) => (
          <DropdownRender
            menu={menu}
            handleSelectAll={handleSelectAll}
            formIds={localityIds}
            dictionaryIds={allIds}
          />
        )}
      />
    </Form.Item>
  );
};
